import type { JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@artosera/ui';
import { useFluxDiffusion, useCreerFlux } from '../../api/diffusion.js';
import { useConnecteurs } from '../../api/connecteurs.js';
import { galerieALaction } from '../../auth/sujet.js';
import { useShellContext } from '../shell/context.js';
import { CarteFlux } from './CarteFlux.js';
import styles from './DiffusionPage.module.css';

export function DiffusionPage(): JSX.Element {
  const { t } = useTranslation(['regie', 'commun']);
  const { galerieSlug, galerie } = useShellContext();
  const liste = useFluxDiffusion(galerieSlug);
  const connecteurs = useConnecteurs(galerieSlug);
  const creer = useCreerFlux(galerieSlug);
  const peutGerer = galerieALaction(galerie, 'diffusion:manage');
  const peutEcrire = galerieALaction(galerie, 'diffusion:write');
  return (
    <div className={styles.page} data-ui="diffusion-page">
      <header data-ui="page-header">
        <h1 className={styles.titre}>{t('regie:diffusion.titre')}</h1>
        <p className={styles.sousTitre}>{t('regie:diffusion.sousTitre')}</p>
      </header>
      {liste.isPending ? <p role="status">{t('commun:chargement')}</p> : null}
      {liste.isError || connecteurs.isError || creer.isError ? (
        <p role="alert">{t('commun:erreurReseau')}</p>
      ) : null}
      {liste.data ? (
        <div className={styles.flux} data-ui="diffusion-feeds">
          {(['artsy', 'artnet'] as const).map((plateforme) => {
            const flux = liste.data.flux.find((f) => f.plateforme === plateforme);
            return flux ? (
              <CarteFlux
                key={`${galerieSlug}-${flux.id}`}
                galerie={galerieSlug}
                plateforme={plateforme}
                connecteur={connecteurs.data?.connecteurs.find((c) => c.id === plateforme)}
                peutGerer={peutGerer}
                peutEcrire={peutEcrire}
              />
            ) : (
              <article key={plateforme} className={styles.carte} data-ui="diffusion-feed">
                <h2>{plateforme === 'artsy' ? 'Artsy' : 'Artnet'}</h2>
                <p>{t('regie:diffusion.ferme')}</p>
                {peutGerer ? (
                  <Button disabled={creer.isPending} onClick={() => creer.mutate(plateforme)}>
                    {t('regie:diffusion.ouvrirFlux', {
                      plateforme: plateforme === 'artsy' ? 'Artsy' : 'Artnet',
                    })}
                  </Button>
                ) : null}
              </article>
            );
          })}
        </div>
      ) : null}
    </div>
  );
}
